import { Image } from '@vinted/web-ui'

import { InfluencerLifestyleCardModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

export const NewLifestyleSectionCard = ({
  title,
  description,
  image,
  index,
}: InfluencerLifestyleCardModel & { index: number }) => (
  <article className="influencer-v2__lifestyle-card" data-testid="influencer-v2__lifestyle-card">
    <div className="influencer-v2__lifestyle-card-image">
      <Image
        src={image.x1Url}
        scaling={Image.Scaling.Fill}
        testId={`lifestyle-card-image-${index}`}
      />
    </div>
    <h3 className="influencer-v2__lifestyle-card-title">{title}</h3>
    <p className="influencer-v2__lifestyle-card-description">{description}</p>
  </article>
)
